var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "apps-integration-preview" } },
    [
      _c("div", { staticClass: "app-info-block" }, [
        !_vm.app.avatar
          ? _c("div", {
              staticClass: "app-avatar-default",
              style: _vm.getAvatarStyle,
              domProps: { innerHTML: _vm._s(_vm.DEFAULT_AVATAR_SVG) },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.app.avatar
          ? _c("img", {
              staticClass: "app-avatar",
              attrs: { src: _vm.app.avatar },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "app-info" }, [
          _c("div", { staticClass: "app-name" }, [
            _vm._v("\n        " + _vm._s(_vm.app.name) + "\n      "),
          ]),
          _vm._v(" "),
          _vm.app.description
            ? _c("div", { staticClass: "app-description" }, [
                _vm._v("\n        " + _vm._s(_vm.app.description) + "\n      "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "app-status",
              class: { "is-online": _vm.app.isActive },
            },
            [_vm._v("\n        " + _vm._s(_vm.appStatusLabel) + "\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "model-value": _vm.app.shareUrl,
          label: _vm.$t("HITL.app-launcher.apps-integration.app-url"),
          readonly: "",
        },
      }),
      _vm._v(" "),
      _c("or-input", {
        attrs: {
          "model-value": _vm.app.shareShortUrl,
          label: _vm.$t("HITL.app-launcher.apps-integration.app-short-url"),
          readonly: "",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "qr-code" },
        [
          _c("or-label", [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("HITL.app-launcher.apps-integration.app-qr-code")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "qr-code-container",
              on: { click: _vm.onQRCodeClick },
            },
            [_c("img", { attrs: { src: _vm.qrCodeSrc } })]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }